import { render } from "./Dosis.vue?vue&type=template&id=3500dfde&scoped=true"
import script from "./Dosis.vue?vue&type=script&lang=js"
export * from "./Dosis.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=3500dfde&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3500dfde"]])

export default __exports__